import gettext from '@sdk/lang/gettext';
import TranslateWithComponents from '@sdk/lang/TranslateWithComponents';

import { useSearchForm } from './searchForm.hooks';
import { ClearButton, Fieldset, Icon, Input, Tips } from './searchForm.styles';

type Props = {
  onFilterQueryChange: (value: string) => void;
};

export const SearchForm = ({ onFilterQueryChange }: Props) => {
  const { handleChange, handleReset, handleSubmit, isSearchResultsActive, query } = useSearchForm({
    onFilterQueryChange,
  });

  return (
    <form onSubmit={handleSubmit}>
      <Fieldset>
        <Icon aria-hidden={true} />
        <Input
          maxLength={50}
          onChange={handleChange}
          placeholder={gettext('search')}
          type="search"
          value={query}
        />
        {query && (
          <ClearButton type="reset" onClick={handleReset}>
            &times;
          </ClearButton>
        )}
      </Fieldset>
      {!isSearchResultsActive && query && (
        <Tips>
          <TranslateWithComponents replaceComponents={{ enterKey: <kbd>enter ⏎</kbd> }}>
            {gettext('press [[enterKey]] to broaden the search')}
          </TranslateWithComponents>
        </Tips>
      )}
    </form>
  );
};
